import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { EmptyState } from '../../components/EmptyState';

interface MyLeadSourcesCardProps {
  data?: Array<{ name: string; count: number }>;
  loading?: boolean;
}

const COLORS = ['#1877F2', '#25D366', '#F5A623', '#8354C6', '#0BA5EC', '#D92D20'];

/** Counselor Dashboard's "My Lead Sources" — this Counselor's own lead
 * sources only, whatever they are (not the fixed Facebook/WhatsApp/
 * Telephone split the company-wide card shows — spec §4/§15). */
export const MyLeadSourcesCard = ({ data, loading }: MyLeadSourcesCardProps) => {
  const rows = data ?? [];
  const total = rows.reduce((sum, r) => sum + r.count, 0);

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        My Lead Sources
      </Typography>
      {rows.length === 0 ? (
        <EmptyState loading={loading} message="No leads yet" />
      ) : (
        <Stack spacing={2}>
          {rows.map((row, index) => {
            const pct = total > 0 ? Math.round((row.count / total) * 100) : 0;
            return (
              <Box key={row.name}>
                <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                  <Typography variant="body2">{row.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {row.count} · {pct}%
                  </Typography>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={pct}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    bgcolor: 'action.hover',
                    '& .MuiLinearProgress-bar': { bgcolor: COLORS[index % COLORS.length], borderRadius: 4 },
                  }}
                />
              </Box>
            );
          })}
        </Stack>
      )}
    </Paper>
  );
};
